<!--选择数量组件-->
<template>
  <div class="input-num-box">
    <div class="reduce-btn" :style="reduceStyle" @click="reduceNum">
      <i class="iconfont icon-jianhao1" style="color: #9c9c9c;"></i>
    </div>
    <input class="input-box" :style="inputStyle" v-model="selectedNum" @input="changeNum" @blur="inputBlur" />
    <div class="reduce-btn" :style="reduceStyle" @click="addNum">
      <i class="iconfont icon-add"></i>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import api from 'api/goods-list';
export default {
  props: {
    productId:{
      //商品id
      type:[Number, String]
    },
    number: {
      //初始数量
      type: Number,
      default: 1,
    },
    height: {
      //尺寸，输入高度
      type: [Number, String],
      default: 30,
    },
    maxNumber: {
      type: [String, Number],
      default: null
    },
    maxError: { //超过最多时的提示
      type: String
    },
    showError: { //超过最多时提示
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedNum: 1,
      max: 200
    };
  },
  computed: {
    //按钮宽高
    reduceStyle() {
      return {
        width: this.height + 'px',
        height: this.height + 'px',
        lineHeight: this.height + 'px',
      };
    },
    //输入框宽高
    inputStyle() {
      return {
        width: this.height * 1.5 + 'px',
        height: this.height + 'px',
      };
    },
  },
  watch: {
    number() {
      this.selectedNum = this.number;
    }
  },
  created() {
    this.selectedNum = this.number;
    this.maxNumber && (this.max = this.maxNumber);
  },
  methods: {
    //输入数量
    async changeNum(type) {
      if (type) {
        this.max = this.maxNumber ? this.maxNumber : await api.getGoodsNum({id:this.productId});
        if (this.max > 200) this.max = 200;
      }
      this.selectedNum = String(this.selectedNum).replace(/[^0-9]/g, '');
      if (this.selectedNum > this.max) {
        this.selectedNum = this.max;
        this.showError && Toast(`该商品最多能买${this.max}件`);
      }
      if (this.selectedNum < 1) this.selectedNum = 1;
      //库存为0
      if (this.max === 0) this.selectedNum = 0;
      this.$emit('update:number', Number(this.selectedNum));
    },
    //减少数量
    reduceNum() {
      this.selectedNum--;
      this.changeNum(0);
      this.$emit('getNumber', Number(this.selectedNum));
    },
    //增加数量
    addNum() {
      this.selectedNum++;
      this.changeNum(1);
      this.$emit('getNumber', Number(this.selectedNum));
    },
    //移除焦点
    inputBlur() {
      this.$emit('getNumber', Number(this.selectedNum));
    },
    //将数字设置成1，在切换规格时需要
    async setInitNum(id) {
      const number = await api.getGoodsNum({id:id?id:this.productId});
      console.log(number);
      if (number === 0) {
        this.selectedNum = 0;
        this.$emit('getNumber', 0);
      }else{
        this.selectedNum = 1;
        this.$emit('getNumber', 1);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.input-num-box {
  display: inline-block;
  .reduce-btn {
    display: inline-block;
    margin: 0 3px;
    background: #f7f7f7;
    text-align: center;
    vertical-align: middle;
  }
  .input-box {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0 5px !important;
    background: #f7f7f7;
    font-size: 12px;
    outline: none;
    border: none;
  }
}
</style>
